<template>
    <div class="block-content block-content-full overflow-hidden mb-2 rounded-12">
        <div class="block w-80">
            <div class="block-header pb-4">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">Informations générales</h3>
            </div>
            <div class="row justify-content-center">
                <div class="col-sm-10 col-md-11">
                    <div class="row justify-content-center">
                        <form @submit.prevent="handleSubmit">
                            <div class="row">
                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="name" class="form-label">Nom<span class="text-purple">*</span></label>
                                        <input v-model="category.name" id="name" class="form-control" placeholder="Nom" />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="subtitle" class="form-label">Sous-titre</label>
                                        <input
                                            v-model="category.subtitle"
                                            id="subtitle"
                                            class="form-control"
                                            placeholder="Sous-titre"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="slug" class="form-label">Slug </label>
                                        <input v-model="category.slug" id="slug" class="form-control" placeholder="Slug" />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="parentCategory" class="form-label">Catégorie parente</label>
                                        <v-select
                                            class="custom-select"
                                            id="parentCategory"
                                            v-model="category.parent_id"
                                            :options="flattenedCategories"
                                            label="indentedTitle"
                                            :placeholder="'Catégorie parente'"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="shortDescription" class="form-label">Courte description</label>
                                        <textarea
                                            v-model="category.short_description"
                                            id="shortDescription"
                                            class="form-control"
                                            placeholder="Courte description"
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="description" class="form-label">Description</label>
                                        <textarea
                                            v-model="category.description"
                                            id="description"
                                            class="form-control"
                                            placeholder="Description"
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <h6 class="fs-6 fw-medium ppv2-text-black pt-1">Afficher cette catégorie (oui/non)</h6>
                                    <div class="form-check form-switch" style="padding-left: 0">
                                        <input
                                            type="checkbox"
                                            id="active"
                                            v-model="category.active"
                                            class="form-control form-check-input"
                                        />
                                    </div>
                                </div>

                                <!-- <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="seoTitle" class="form-label">SEO Title:</label>
                                        <input
                                            v-model="category.seo_title"
                                            id="seoTitle"
                                            class="form-control"
                                            placeholder="SEO Title"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="seoKeywords" class="form-label">SEO Keywords:</label>
                                        <input
                                            v-model="category.seo_keywords"
                                            id="seoKeywords"
                                            class="form-control"
                                            placeholder="SEO Keywords"
                                        />
                                    </div>
                                </div> -->
                            </div>

                            <!-- <div class="col-lg-12 col-xs-12">
                                <div class="form-group">
                                    <label for="seoDescription" class="form-label">SEO Description:</label>
                                    <textarea
                                        v-model="category.seo_description"
                                        id="seoDescription"
                                        class="form-control"
                                        placeholder="SEO Description"
                                    ></textarea>
                                </div>
                            </div> -->

                            <div class="d-flex justify-content-center mt-4 flex-wrap mx-6">
                                <a
                                    href="/back-office/food/category"
                                    class="btn btn-outline-dark line_height41 mx-4 mt-4 rounded-12 fw-semibold width-btn height_btn_page"
                                >
                                    Annuler
                                </a>
                                <button
                                    type="submit"
                                    class="btn btn-dark rounded-12 mx-4 mt-4 fw-semibold width-btn height_btn_page"
                                >
                                    {{ Object.keys(this.data).length === 0 ? 'Ajouter' : 'Mettre à jour' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiManager from '../Api/ApiManagerFood.js'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    props: ['data'],
    data() {
        return {
            category: {
                name: '',
                subtitle: '',
                active: true,
                description: '',
                seo_description: '',
                seo_title: '',
                seo_keywords: '',
                short_description: '',
                image: '',
                parent_id: '-- Selectionne la catégorie --',
            },
            parentCategories: [],

            categoriesWithHierarchy: [],
        }
    },

    computed: {
        flattenedCategories() {
            return this.flattenCategories(this.categoriesWithHierarchy)
        },
    },

    methods: {
        handleSubmit() {
            if (Object.keys(this.data).length !== 0) {
                console.log('update')
                this.updateCategory()
            } else {
                console.log('create')
                this.createCategory()
            }
        },

        createCategory() {
            if (this.category.parent_id === '-- Selectionne la catégorie --') {
                this.category.parent_id = null
            }

            axios
                .post('/back-office/food/category', this.category)
                .then((response) => {
                    console.log('Category created:', response.data)
                    window.location.href = '/back-office/food/category/'
                })
                .catch((error) => {
                    console.error('Error creating category:', error)
                })
        },

        updateCategory() {
            const categoryId = this.data.id
            axios
                .put(`/back-office/food/category/${categoryId}`, this.category)
                .then((response) => {
                    console.log('Category updated:', response.data)
                    this.$toast.success(this.$t('food.categories.updated_success'))
                })
                .catch((error) => {
                    console.error('Error updating category:', error)
                })
        },

        async fetchParentCategories() {
            try {
                const data = await ApiManager.fetchParentCategories()
                this.parentCategories = data.data
                this.categoriesWithHierarchy = this.buildHierarchy(this.parentCategories, null)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //throw error; // Rethrow the error if needed
            }
        },

        buildHierarchy(categories, parentId = null) {
            const filteredCategories = categories.filter((category) => category.parent_id === parentId)
            const hierarchy = []
            filteredCategories.forEach((category) => {
                const children = this.buildHierarchy(categories, category.id)
                if (children.length) {
                    category.children = children
                }
                hierarchy.push(category)
            })
            return hierarchy
        },

        flattenCategories(categories, depth = 0) {
            let flattened = []
            if (categories.length > 0) {
                categories.forEach((category) => {
                    flattened.push({
                        id: category.id,
                        indentedTitle: `${'-'.repeat(depth)} ${category.name}`,
                    })
                    if (category.children && category.children.length > 0) {
                        flattened = flattened.concat(this.flattenCategories(category.children, depth + 1))
                    }
                })
            }
            return flattened
        },
    },

    mounted() {
        if (Object.keys(this.data).length !== 0) {
            this.category = { ...this.data }
            this.category.parent_id = {
                id: this.data?.parent?.id,
                indentedTitle: this.data?.parent?.name,
            }
        }
        this.fetchParentCategories()
    },

    components: {
        vSelect,
    },
}
</script>

<style scoped>
#parentCategory .vs__dropdown-toggle,
#kitchen .vs__dropdown-toggle {
    color: #94a3b8;
    background-color: #fff;
    border-color: #e2e8f0;
    border-radius: 12px;
    height: 50px;
}
.vs__clear {
    fill: #94a3b8;
    margin-right: 12px;
    margin-bottom: 1px;
}
.vs__dropdown-menu {
    height: 200px;
    border-radius: 12px;
}
.vue-notification.error {
    background: linear-gradient(90deg, rgba(249, 233, 233, 1) 0%, rgba(249, 235, 236, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #de2c2c;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    max-height: 100px;
    width: fit-content !important;
    border-radius: 8px;
    line-height: 38px;
    max-width: fit-content !important;
    z-index: 9999;
    right: 35px !important;
    top: 60px !important;
}
.vue-notification-title {
    border-bottom: none;
    font-size: 16px;
    font-family: 'Poppins Regular';
    color: #021832 !important;
    margin-left: 10px;
}
.vue-notification.success {
    background: linear-gradient(90deg, rgba(227, 248, 235, 1) 0%, rgba(238, 249, 243, 1) 24%, rgba(255, 255, 255, 1) 100%);
    border-bottom: 6px solid #01e17b !important;
    border: none;
    box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.1);
    max-height: 100px;
    width: max-content !important;
    border-radius: 8px;
    line-height: 38px;
    max-width: fit-content !important;
    z-index: 9999;
    right: 35px !important;
    top: 60px !important;
}
.error .vue-notification-title::before {
    content: url('/media/cancel.svg');
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    top: 45%;
    transform: translateY(-50%);
    background-size: cover;
}
.success .vue-notification-title::before {
    content: url('/media/check_circle.svg');
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    left: 10px;
    top: 45%;
    transform: translateY(-50%);
    background-size: cover;
}
</style>
